import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  static values = {
    allNestedTitles: { type: Boolean, default: false }
  };

  connect() {
    this.tooltipElements = [];
    this.initializeTooltips();
    this.beforeMorph = (event) => {
      if (event.target === this.element) this.disposeTooltips();
    };
    this.afterMorph = (event) => {
      if (event.target === this.element) this.initializeTooltips();
    };
    this.hideAll = () => {
      // Dispose instead of hide to avoid async hide callbacks after Turbo removes a trigger.
      this.disposeTooltips();
      this.initializeTooltips();
    };
    this.beforeCache = () => this.disposeTooltips();
    this.element.addEventListener('click', this.hideAll);
    this.element.addEventListener('turbo:before-morph-element', this.beforeMorph);
    this.element.addEventListener('turbo:morph-element', this.afterMorph);
    document.addEventListener('turbo:before-cache', this.beforeCache);
  }

  disconnect() {
    this.element.removeEventListener('click', this.hideAll);
    this.element.removeEventListener('turbo:before-morph-element', this.beforeMorph);
    this.element.removeEventListener('turbo:morph-element', this.afterMorph);
    document.removeEventListener('turbo:before-cache', this.beforeCache);
    this.disposeTooltips();
  }

  initializeTooltips() {
    const elements = this.allNestedTitlesValue ? this.element.querySelectorAll('[title]') : [this.element];
    for (const element of elements) {
      // Nested controllers own their tooltips, even within an all-nested-titles group.
      if (element.closest('[data-controller~="tooltip"]') !== this.element) continue;
      Tooltip.getOrCreateInstance(element, { container: element.closest('dialog') || false });
      if (!this.tooltipElements.includes(element)) this.tooltipElements.push(element);
    }
  }

  disposeTooltips() {
    // Bootstrap restores title on disposal, before morphing applies the server's new title.
    this.tooltipElements.forEach((element) => Tooltip.getInstance(element)?.dispose());
    this.tooltipElements = [];
  }
}
